import { Dialog } from '@cimplico/components';
import { useUpdateWorkpaperProcedures } from '../../queries/use-update-workpaper-procedures';
import { WorkpaperProcedureStatusEnum } from '../../types/workpaper-procedure';
import { toastNotification } from '../../components/toast/Toast';
import plural from '../../utilities/plural';

type WorkpaperProcedureActiveDialogProps = {
    workpaperId: string;
    procedureIds: string[];
    isOpen: boolean;
    onClose: () => void;
    onUpdate: () => void;
};

function WorkpaperProcedureActiveConfirmDialog({
    isOpen,
    procedureIds,
    workpaperId,
    onClose,
    onUpdate,
}: WorkpaperProcedureActiveDialogProps): JSX.Element {
    const updateProceduresQuery = useUpdateWorkpaperProcedures(workpaperId);

    function updateProcedure(): void {
        updateProceduresQuery.mutate(
            procedureIds.map((id) => ({ id, fields: { status: WorkpaperProcedureStatusEnum.ACTIVE } })),
            {
                onSuccess: () => {
                    onUpdate();
                    if (procedureIds.length > 1) {
                        toastNotification('success', `${procedureIds.length} procedures marked as active!`);
                    }
                },
            }
        );
    }

    return (
        <Dialog
            description={`Do you want to mark ${procedureIds.length} ${plural(
                procedureIds.length,
                'procedure',
                'procedures'
            )} as Applicable?`}
            onClose={onClose}
            onPrimaryActionClick={updateProcedure}
            onSecondaryActionClick={onClose}
            isOpen={isOpen}
            primaryAction="Confirm"
            secondaryAction="Cancel"
            title="Applicable"
            type="success"
            isLoading={updateProceduresQuery.isLoading}
        />
    );
}

export default WorkpaperProcedureActiveConfirmDialog;
